/*eslint-disable*/
export const APP_CONFIG = {
  serverUrl: process.env.REACT_APP_SERVER_URL,
  apiServerUrl: process.env.REACT_APP_API_SERVER_URL,
  apiServerAppleJsSignUpCallback: process.env.REACT_APP_APPLE_LOGIN_REDIRECT_URL,
  appleJsUrl: process.env.REACT_APP_APPLE_JS_URL,
  appleMusicKitJsUrl: process.env.REACT_APP_APPLE_MUSIC_KIT_JS_URL,
};
